module.exports = __webpack_public_path__ + "img/ico_yuemaiyuezhi.25c53937.png";